var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "g-app-wrapper", attrs: { id: "app" } },
    [
      _c("g-nav", { on: { noticeType: _vm.noticeType } }),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "navFlag",
          staticClass: "g-main",
          style: { marginTop: _vm.typeTip ? "102px" : "67px" }
        },
        [
          _c(
            "keep-alive",
            { attrs: { include: _vm.keepAliveList } },
            [_vm.isRouterAlive ? _c("router-view") : _vm._e()],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("g-footer"),
      _vm._v(" "),
      _c("fixed-btn"),
      _vm._v(" "),
      _c("c-progress", {
        ref: "progress",
        attrs: { percentage: _vm.progressPercentage, text: _vm.progressText }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-182a0d89", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-182a0d89","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/baseFrame/baseFrame.vue
// module id = null
// module chunks = 